import { render, staticRenderFns } from "./order-dialog.vue?vue&type=template&id=2189e08e"
import script from "./order-dialog.vue?vue&type=script&lang=js"
export * from "./order-dialog.vue?vue&type=script&lang=js"
import style0 from "./order-dialog.vue?vue&type=style&index=0&id=2189e08e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports